export default theme => ({
  root: {
    flexGrow: 1,
    padding: [[theme.spacing(3), 0]],
    [theme.breakpoints.up('lg')]: {
      paddingTop: theme.spacing(11),
    },
  },
});
